export default "<h1>Kontakt</h1>\r\n";